"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleStore = function () {
	function SimpleStore(url) {
		_classCallCheck(this, SimpleStore);

		this.api = _axios2.default.create({
			baseURL: url,
			headers: { cache: "no-cache" }
		});
	}

	_createClass(SimpleStore, [{
		key: "get",
		value: function get(key) {
			return this.api.get("get/" + key).then(this._adaptResponse);
		}
	}, {
		key: "save",
		value: function save(key, value) {
			var data = encodeURIComponent(value);
			return this.api.get("set/" + key + "/" + data).then(this._adaptResponse);
		}
	}, {
		key: "_adaptResponse",
		value: function _adaptResponse(response) {
			var data = response.data;

			return data.value;
		}
	}]);

	return SimpleStore;
}();

exports.default = SimpleStore;